import { useQuery } from '@tanstack/react-query';

import { assetKeys } from '@/shared/lib/query/queryKeys';

import { fetchServiceMLModels } from '@/features/asset-detail/api/mlmodelsApi';
import type { FetchMLModelsOptions, MLModelsResponse } from '@/features/asset-detail/api/mlmodelsApi';

export const useServiceMLModels = (
  serviceName: string,
  options: FetchMLModelsOptions = {},
  enabled: boolean = true
) => {
  return useQuery<MLModelsResponse | null>({
    queryKey: assetKeys.serviceMLModels(serviceName, options.includeDeleted ?? false),
    queryFn: async () => {
      if (!enabled) {
        return null;
      }
      return fetchServiceMLModels(serviceName, options);
    },
    enabled: enabled && !!serviceName,
    staleTime: 5 * 60 * 1000,
    retry: 1,
  });
};
